module.exports = __webpack_public_path__ + "img/after4-Recovered.d171439b.png";